export default {
  // domain: /t\d\.dy\.163\.com/.test(window.location.host) ? 'test1.upload.buzz.163.com' : 'upload.buzz.163.com',
  domain: window.location.host,
  uploadtype: 'cms',
  bucketName: 'dingyue',
  from: 'neteasecode_mp',
};
